import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LegacyButton from '../LegacyButton';
import LegacyButtonGroup from '../LegacyButtonGroup';
import Typography from '../Typography';
import Select from '../Select';

const StudyListPagination = ({ onChangePage, currentPage, perPage, onChangePerPage }) => {
  const { t } = useTranslation('StudyList');

  const navigateToPage = page => {
    const toPage = page < 1 ? 1 : page;
    onChangePage(toPage);
  };

  const ranges = [
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];
  const [selectedRange, setSelectedRange] = useState(ranges.find(r => r.value === perPage));
  const onSelectedRange = selectedRange => {
    setSelectedRange(selectedRange);
    onChangePerPage(selectedRange.value);
  };

  return (
    <div className="mb-12 bg-black py-6">
      <div className="container m-auto px-4">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          {/* Select + label */}
          <div className="flex flex-col items-center sm:flex-row sm:items-center sm:gap-4">
            <Select
              id="rows-per-page"
              className="border-primary-main mb-2 w-24 sm:mb-0"
              options={ranges}
              value={selectedRange}
              isMulti={false}
              isClearable={false}
              isSearchable={false}
              closeMenuOnSelect={false}
              hideSelectedOptions={true}
              onChange={onSelectedRange}
            />
            <Typography className="text-sm text-white opacity-70">
              {t('Results per page')}
            </Typography>
          </div>

          {/* Pagination controls */}
          <div className="flex flex-col items-center gap-2 sm:flex-row sm:gap-4">
            <Typography className="text-sm text-white opacity-70">
              {t('Page')} {currentPage}
            </Typography>

            <LegacyButtonGroup>
              <LegacyButton
                size="initial"
                className="px-3 py-3 text-sm"
                color="translucent"
                border="primary"
                variant="outlined"
                onClick={() => navigateToPage(1)}
              >
                {`<<`}
              </LegacyButton>
              <LegacyButton
                size="initial"
                className="px-3 py-3 text-sm"
                color="translucent"
                border="primary"
                variant="outlined"
                onClick={() => navigateToPage(currentPage - 1)}
              >
                {t('Previous')}
              </LegacyButton>
              <LegacyButton
                size="initial"
                className="px-3 py-3 text-sm"
                color="translucent"
                border="primary"
                variant="outlined"
                onClick={() => navigateToPage(currentPage + 1)}
              >
                {t('Next')}
              </LegacyButton>
            </LegacyButtonGroup>
          </div>
        </div>
      </div>
    </div>
  );
};

StudyListPagination.propTypes = {
  onChangePage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  onChangePerPage: PropTypes.func.isRequired,
};

export default StudyListPagination;
